<template>
  <div class="hero">
    <div class="hero-body is-full">
    <div class="hero-body container container box has-background-white-bis">
      <form class="has-text-centered" data-vv-scope="step1">
        <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
        <section class="has-text-left">
          <div class="notification has-background-grey-dark has-text-white">
            Please update vehicle valet status.
          </div>
          <div class="is-full">
            <div class="columns is-multiline">
              <div class="column is-12">
                <div class="field" v-if="currentRoService && currentRoService.roServiceVehicle">
                  <span class="is-inline-block" style="font-weight:bold;" v-html="makeOverview(currentRoService.roServiceVehicle)"></span>
                </div>
                <div class="field" v-if="currentRoService && !currentRoService.roServiceVehicle">
                    <span class="is-inline-block" style="font-weight:bold;">Vehicle details not available</span>
                </div>
              </div>
              <div class="column is-12">
                <multiselect
                  :multiple="false"
                  name="valetStatus"
                  v-validate="{ 'required': true }"
                  :class="{ 'is-danger': errors.has('valetStatus') }"
                  data-vv-as="valet status"
                  placeholder="Select Valet Status"
                  label="name"
                  track-by="id"
                  :options="valetWashingStatusOptions"
                  :searchable="true"
                  v-model="selectedValetStatus">
                </multiselect>
              </div>
                <div class="box column is-12" v-if="currentRoService && currentRoService.valetStatusHistoryItems && currentRoService.valetStatusHistoryItems.length > 0">
                  <div class="column is-narrow" style="padding-right:0">
                    <span class="is-6 is-inline-block" style="font-weight:bold; font-size: 1.125rem;">Valet Status History</span>
                  </div>
                  <br />
                  <table class="table is-bordered is-narrow is-hoverable is-fullwidth">
                    <thead>
                      <tr>
                        <th>To Status</th>
                        <th>Actioned By</th>
                        <th>Actioned On</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="valetStatusHistoryItem in currentRoService.valetStatusHistoryItems" :key="valetStatusHistoryItem.id">
                        <td>{{ getStatusDescription(valetStatusHistoryItem.newValetStatus)}}</td>
                        <td>{{ valetStatusHistoryItem.actionedBy}}</td>
                        <td>{{ valetStatusHistoryItem.createdAt | formatDate }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>
          </div>
        </section>
      </form>
      <br>
      <div>
        <button class="button" @click="validateBeforeSubmit" :disabled="!statusValueChanged"> Save</button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import _ from 'lodash'
import utilitiesMixin from '@/mixins/generic/utilities'
import roServiceService from '@/services/roServiceService'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'

const mapConfigGetters = createNamespacedHelpers('config').mapGetters
export default {
  name: 'ValetStatusUpdate',
  components: {
    'error-display-component': ErrorDisplayComponent
  },
  inject: {
    $validator: '$validator'
  },
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  mixins: [validateBeforeSubmitMixin, utilitiesMixin],
  data () {
    return {
      isLoading: false,
      selectedValetStatus: null,
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: '',
      isValidToken: false,
      currentUser: null,
      currentRoService: null,
      initialValetStatus: null,
      latestValetNote: ''
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    valetWashingStatusOptions: function () {
      return this.definedTypes.valetWashingStatus.options
    },
    statusValueChanged: function () {
      if (!this.initialValetStatus && !this.selectedValetStatus) {
        return false
      } else if (this.initialValetStatus && this.selectedValetStatus && this.initialValetStatus.name === this.selectedValetStatus.name) {
        return false
      } else if (!this.initialValetStatus && this.selectedValetStatus) {
        return true
      } else if (this.initialValetStatus && !this.selectedValetStatus) {
        return true
      } else if (this.initialValetStatus && this.selectedValetStatus && this.initialValetStatus.name !== this.selectedValetStatus.name) {
        return true
      }
      const comparison = _.isEqual(this.selectedValetStatus, this.initialValetStatus)
      return !comparison
    },
    latestNote: function () {
      if (this.latestValetNote.length > 0) {
        return this.latestValetNote
      }
      return ''
    }
  },
  created () {
    this.$emit('is-home', false)
  },
  mounted () {
    this.fetchIdentityVerification(this.token)
    this.$emit('set-title-one', 'WASHING')
    this.$emit('set-title-two', 'STATUS')
  },
  methods: {
    fetchIdentityVerification: function (currentToken) {
      const that = this
      this.currentRoService = null
      this.currentUser = null
      this.serverErrorMessage = ''
      this.loadingBaseData = true
      this.isLoading = true
      roServiceService.getRoServiceInformation(currentToken).then(response => {
        that.currentUser = {
          ...response.data.userData
        }
        that.currentRoService = {
          ...response.data.roService
        }
        const valetNotes = that.currentRoService.notes.filter(function (el) {
          return el.note.includes('Vehicle valet status')
        })
        if (valetNotes.length > 0) {
          that.latestValetNote = valetNotes[0].note
        }
        that.dealerId = that.currentRoService.roServiceCustomer.dealerId
        if (!that.dealerId || that.dealerId === 0) {
          that.serverErrorMessage = 'Could not load R.O. service vehicle washing status information with token: ' + currentToken
        } else {
          that.isValidToken = true
          that.isLoading = false
          that.initInputValues()
        }
        // eslint-disable-next-line handle-callback-err
      }).catch((error) => {
        that.isLoading = false
        that.serverErrorMessage = 'Could not load R.O. service vehicle washing status information  with token: ' + currentToken
        that.isValidToken = false
      })
    },
    initInputValues: function () {
      this.selectedValetStatus = this.currentRoService.valetStatus ? this.valetWashingStatusOptions.find(x => x.altName === this.currentRoService.valetStatus) : null
      this.initialValetStatus = this.selectedValetStatus
    },
    makeOverview: function (inventory) {
      if (!inventory) {
        return ''
      }
      var result = ''
      result = inventory.vin
      result += '<br /> ' + inventory.name
      if (inventory.color) {
        result += '<br /> Ext. Color (' + inventory.color + ')'
      }
      return result
    },
    onSave: function () {
      const that = this
      this.isSaving = true
      this.serverErrorMessage = ''
      this.serverErrors = []
      const updateWashingStatusModel = {
        token: this.token,
        roServiceId: this.currentRoService.id,
        valetStatus: this.selectedValetStatus.altName,
        userId: this.currentUser.id
      }

      roServiceService.updateServiceVehicleValetStatus(updateWashingStatusModel).then(response => {
        that.isSaving = false
        if (response.errors) {
          that.serverErrors = response.errors
          that.$nextTick(function () {
            var elmnt = document.getElementById('main-page')
            elmnt.scrollTo(0, 0)
          })
        } else {
          that.onChangesSaved()
          that.onComplete()
        }
      }).catch((error) => {
        that.serverErrorMessage = error.message
        that.isSaving = false
        that.$nextTick(function () {
          var elmnt = document.getElementById('main-page')
          elmnt.scrollTo(0, 0)
        })
      })
    },
    onComplete () {
      this.fetchIdentityVerification(this.token)
    },
    getStatusDescription: function (valetStatus) {
      const result = this.currentRoService.valetStatus ? this.valetWashingStatusOptions.find(x => x.altName === valetStatus) : null
      if (result) {
        return result.name
      }
      return valetStatus
    }
  },
  watch: {
    token: function (newValue, oldValue) {
      this.isValidToken = false
      this.fetchIdentityVerification(this.token)
    }
  }
}
</script>
